<script>
export default {
  name: 'TimelineEntryItem',
};
</script>

<template>
  <li class="timeline-entry">
    <div class="timeline-entry-inner"><slot></slot></div>
  </li>
</template>
